import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import {HTTP} from '@/utils/httpCommonUtil';
import {BallPulseLoader} from 'vue-loaders';
import InvoiceEventHub from '@/components/invoice/InvoiceEventHub';
import WarningModal from '@/componentsReusable/WarningModal.vue';
import {InvoiceStatus} from '@/enums/invoiceStatusEnum';

export default Vue.component('invoice-special-notes', {
  name: 'InvoiceSpecialNotes',
  props: {
    'facilityId': { type: String, Number },
    'specialtyId': { type: String, Number },
    'invoiceDate': { type: String, Number },
    'invoiceId': { type: [String, Number] },
    'mergedInvoiceId': { type: [Number, String] }
  },
  created: function () {
    InvoiceEventHub.$on('INVOICE_CHANGE', this.dataFetchWrapper);
  },
  beforeDestroy: function () {
    InvoiceEventHub.$off('INVOICE_CHANGE', this.dataFetchWrapper);
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    WarningModal
  },
  mixins: [ HttpMixin ],
  data() {
    return {
      cardExpanded: false,
      invoice: null as any,
      saving: false,
      showSaveModal: false
    };
  },
  methods: {
    // this comment copypasta is to denote that this function is to work around a leak caused by using anonymous functions in the event callback.
    // per this issue comment https://github.com/vuejs/vue-router/issues/1181#issuecomment-281084486
    // testing bears this out to be true and was causing unnecessary data fetches as well as bugs with incorrect route redirects
    dataFetchWrapper() {
      this.loadSpecialNoteData().then(() => {}).catch(() => '');
    },
    async expandCard(): Promise<void> {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.loadSpecialNoteData();
      }
    },
    async loadSpecialNoteData () {
      let parameters;
      if (this.invoiceId) {
        parameters = `invoiceId=${this.invoiceId}`;
      } else if (this.mergedInvoiceId) {
        parameters = `mergedInvoiceId=${this.mergedInvoiceId}`;
      } else if (this.facilityId && this.specialtyId && this.invoiceDate) {
        parameters = `facilityId=${this.facilityId}&specialtyId=${this.specialtyId}&invoiceDate=${this.invoiceDate}`;
      } else {
        throw new Error("Error retrieving Invoice Information");
      }
      const data = await (this as any).httpGet(`/invoices/info?${parameters}`, 'Failed to load Special Note');
      if (data && data.length > 0) {
        this.invoice = data[0];
      } else {
        this.invoice = null;
      }
    },
    async save(overrideWarning: boolean): Promise<void> {
      if (this.invoiceId && !overrideWarning && this.invoice!.invoiceStatusId !== InvoiceStatus.IN_REVISION) {
        this.showSaveModal = true;
        return;
      } else {
        this.showSaveModal = false;
      }
      this.saving = true;
      try {
        let url = 'api/invoices';
        if (this.invoiceId) {
          url += `/${this.invoiceId}/special-notes`;
        }
        await HTTP.put(url, this.invoice);
        InvoiceEventHub.$emit('INVOICE_NOTE_CHANGE');
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Saved',
          text: 'Special Note saved.'
        });
        this.saving = false;
      } catch (err) {
        this.saving = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred saving Special Note.'
        });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoice/cards/special/InvoiceSpecialNotesCard.ts